import { MESSAGES_COPY } from '../messages/COPY';

export const SUBDOMAIN = {
	MESSAGE: MESSAGES_COPY.INVALID_SUBDOMAIN,
	PATTERN: /^[a-zA-Z0-9-]+$/u
};
